import React from "react";
import Shopping from "./Shopping";
import styles from "./Shopping.module.css";
import useWeeeShopping from "./useWeeeShopping";
import { weeeAdapter } from "./shoppingItemAdapter";

const WeeeShoppingItem = ({ onClick, shoppingItemInfo }) => {
  return (
    <div className={styles.ShoppingItem} onClick={() => onClick(shoppingItemInfo)}>
      <div className={styles.shoppingItemImgWrapper}>
        <img src={shoppingItemInfo.img} alt="" />
      </div>
      <div className={styles.ShoppingItemInfo}>
        <div>{shoppingItemInfo.name}</div>
        <span>$ {shoppingItemInfo.price}</span>
      </div>
    </div>
  );
};

const WeeeShopping = props => {
  return <Shopping {...props} useShopping={useWeeeShopping} shoppingItem={WeeeShoppingItem} adapter={weeeAdapter} />;
};

export { WeeeShopping };
